import { render, staticRenderFns } from "./PlatoViewer.vue?vue&type=template&id=1dc1a0c8&"
import script from "./PlatoViewer.vue?vue&type=script&lang=js&"
export * from "./PlatoViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports